
import { defineComponent } from "vue";
import { SateliteEstimation, SateliteImage } from "@/types/satelitalSamplingPoint.type";
import SatelitalChartComponent from "@/components/satelital/SatelitalChart.component.vue";
import { dateFormatDate } from "@/utils/date.utils";
import { getParameterData, getSatelitalById } from "@/service/satelital.service";
import SatelitalImageComponent from "./SatelitalImage.component.vue";
import SatelitalImageModalComponent from "./SatelitalImageModal.component.vue";

export default defineComponent({
  components: {
    SatelitalImageComponent,
    SatelitalImageModalComponent,
    SatelitalChartComponent,
  },
  props: {
    satelitalSamplingPointId: { type: Number, required: true, immediate: true, deep: true },
  },
  setup() {
    return { dateFormatDate };
  },
  watch: {
    satelitalSamplingPointId: async function (satelitalSamplingPointsId: number) {
      if (satelitalSamplingPointsId >= 0) {
        this.satelitalPoint = await getSatelitalById(satelitalSamplingPointsId);
        this.parameterGraph =
          this.satelitalPoint.estimations && this.satelitalPoint.estimations[0].parameter
            ? this.satelitalPoint.estimations[0].parameter
            : "";
        this.resetDates();
        this.getParameterHistory();
      } else {
        this.satelitalPoint = undefined;
      }
    },
    parameterGraph: async function (newValue: string) {
      this.parameterGraph = newValue;
      this.getParameterHistory();
    },
  },
  mounted() {
    // this.resetDates();
  },
  data() {
    return {
      satelitalPoint: undefined as SateliteImage | undefined,
      parameterGraph: "" as string,
      startDate: new Date(),
      endDate: new Date(),
      parameterHistory: [] as SateliteEstimation[],
      dataCollection: [] as Array<{ date: number; value: number | undefined; altValue: any }>,
      dialogImage: undefined as SateliteImage | undefined,
      dialogImageTitle: "" as string,
      dialogImageVisible: false,
      dialogInfoParamVisible: false,
      dialogInfoParam: "" as string,
    };
  },
  methods: {
    changeParameterGraph(parameter: string) {
      this.parameterGraph = parameter;
    },
    async getParameterHistory() {
      if (
        !this.satelitalPoint ||
        !this.satelitalPoint.samplingPoint ||
        !this.satelitalPoint.samplingPoint.id
      ) {
        return;
      }

      this.parameterHistory = (
        await getParameterData(
          this.parameterGraph,
          this.satelitalPoint?.samplingPoint?.id,
          this.startDate,
          this.endDate
        )
      ).reverse();

      this.dataCollection = this.parameterHistory.map((item) => ({
        date: item.image?.dateTime ? new Date(item.image.dateTime).getTime() : new Date().getTime(),
        // value: item.value ?? undefined,
        value: item.value ?? 0,
        altValue: item.value,
      }));
      // Formatear los datos para el componente de la gráfica
    },
    showLastMonth() {
      this.resetDates();
      this.getParameterHistory();
    },
    showLastTrimester() {
      this.removeBlueClass();
      this.addBlueClass("btnTri");
      const actualDate = new Date();
      this.startDate = new Date(
        actualDate.getFullYear(),
        actualDate.getMonth() - 3,
        actualDate.getDate(),
        actualDate.getHours(),
        actualDate.getMinutes(),
        actualDate.getSeconds()
      );
      this.endDate = actualDate;
      this.getParameterHistory();
    },
    showLastSemester() {
      this.removeBlueClass();
      this.addBlueClass("btnSem");
      const actualDate = new Date();
      this.startDate = new Date(
        actualDate.getFullYear(),
        actualDate.getMonth() - 6,
        actualDate.getDate(),
        actualDate.getHours(),
        actualDate.getMinutes(),
        actualDate.getSeconds()
      );
      this.endDate = actualDate;
      this.getParameterHistory();
    },
    showLastYear() {
      this.removeBlueClass();
      this.addBlueClass("btnYear");
      const actualDate = new Date();
      this.startDate = new Date(
        actualDate.getFullYear() - 1,
        actualDate.getMonth(),
        actualDate.getDate(),
        actualDate.getHours(),
        actualDate.getMinutes(),
        actualDate.getSeconds()
      );
      this.endDate = actualDate;
      this.getParameterHistory();
    },
    resetDates() {
      this.removeBlueClass();
      this.addBlueClass("btnMonth");
      const actualDate = new Date();
      this.startDate = new Date(
        actualDate.getFullYear(),
        actualDate.getMonth() - 1,
        actualDate.getDate(),
        actualDate.getHours(),
        actualDate.getMinutes(),
        actualDate.getSeconds()
      );
      this.endDate = actualDate;
    },
    removeBlueClass() {
      const blueBtn = document.getElementsByClassName("blue");
      if (blueBtn[0]) {
        blueBtn[0].className = blueBtn[0].className.replace("blue", "");
      }
    },
    addBlueClass(idBtn: string) {
      const btnDate = document.getElementById(idBtn);
      btnDate?.classList.add("blue");
    },
    // clickChartPoint(event: ChartEvent, elements: ActiveElement[], chart: Chart) {
    //   if (elements.length === 0) {
    //     return;
    //   }

    //   // - get image and tile by chart point index
    //   const index = elements[0].index;
    //   const parameterHistory = toRaw(this.parameterHistory);
    //   if (parameterHistory[index].image !== undefined) {
    //     this.dialogImage = parameterHistory[index].image;
    //     this.dialogImageVisible = true;
    //     this.dialogImageTitle =
    //       this.satelitalPoint?.samplingPoint?.samplingPoint?.name + " " + chart.tooltip?.title[0] ||
    //       "";
    //   } else {
    //     this.dialogImageClose();
    //   }
    // },
    dialogImageClose() {
      this.dialogImage = undefined;
      this.dialogImageTitle = "";
      this.dialogImageVisible = false;
    },
    dialogInfoParamOpen(param: string) {
      (this.dialogInfoParamVisible = true), (this.dialogInfoParam = param);
    },
  },
});
